import { BaseApiClass } from "@/js/api/base.ts"
import { EventsIndexRequest, EventIndexResponse } from "@/js/types/generated"

export class CalendarAPI extends BaseApiClass {
	public async index(request: EventsIndexRequest): Promise<EventIndexResponse> {
		const response = await this.axios.get<EventIndexResponse>("events", {
			params: request,
		})
		return response.data
	}
}
